function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.125 13.2979H0.866C0.39 13.2979 0 13.6479 0 14.0739C0 14.4999 0.39 14.8499 0.866 14.8499H15.134C15.61 14.8499 16 14.4999 16 14.0739C16 13.6479 15.61 13.2979 15.125 13.2979Z",
  fill: "#333333"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.99651 1C7.69251 1 7.44551 1.248 7.44551 1.553V9.607L4.30051 6.214C4.19651 6.105 4.05751 6.042 3.90851 6.039C3.76451 6.024 3.62951 6.087 3.52651 6.185C3.30451 6.397 3.29051 6.747 3.49651 6.964L7.59551 11.383C7.81151 11.613 8.18351 11.611 8.39851 11.383L12.5015 6.965C12.6025 6.859 12.6545 6.72 12.6495 6.573C12.6445 6.423 12.5825 6.286 12.4755 6.187C12.3695 6.085 12.2175 6.03 12.0845 6.039C11.9365 6.043 11.7995 6.105 11.7005 6.213L8.54651 9.606V1.553C8.54651 1.248 8.29951 1 7.99651 1Z",
  fill: "#333333"
});

var SvgDownloadIcon = function SvgDownloadIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Download_icon.5651784e.svg";
export { ForwardRef as ReactComponent };